module.exports = __webpack_public_path__ + "assets/images/05HB.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05HB.png
// module id = 1262
// module chunks = 1